module.exports = __webpack_public_path__ + "img/Singapore.24477891.jpg";